import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "zszx-wrapper"
};
const _hoisted_2 = {
  class: "zszx-page"
};
const _hoisted_3 = {
  key: 0,
  class: "section"
};
const _hoisted_4 = {
  class: "intro-content"
};
const _hoisted_5 = {
  class: "intro-image"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "intro-text"
};
const _hoisted_8 = {
  key: 1,
  class: "section"
};
const _hoisted_9 = {
  class: "project-cards"
};
const _hoisted_10 = {
  class: "card-label"
};
const _hoisted_11 = {
  class: "card-value"
};
const _hoisted_12 = {
  key: 2,
  class: "section success-cases-section"
};
const _hoisted_13 = {
  class: "success-cases-container"
};
const _hoisted_14 = {
  class: "cases-carousel"
};
const _hoisted_15 = {
  class: "cases-grid"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "case-image"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "case-content"
};
const _hoisted_20 = {
  class: "case-title"
};
const _hoisted_21 = {
  class: "case-date"
};
const _hoisted_22 = {
  class: "case-desc"
};
const _hoisted_23 = {
  key: 3,
  class: "section"
};
const _hoisted_24 = {
  class: "workflow-image"
};
const _hoisted_25 = ["src"];
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import SectionTitle from '@/components/SectionTitle.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { getPilotCenterInfo } from '@/api/pilot';
export default /*@__PURE__*/_defineComponent({
  __name: 'Zszx',
  setup(__props) {
    const router = useRouter();
    const pilotInfo = ref(null);
    const loading = ref(false);
    const goToDetail = id => {
      router.push(`/xwxq/${id}`);
    };
    onMounted(async () => {
      loading.value = true;
      try {
        const response = await getPilotCenterInfo();
        pilotInfo.value = response.data;
        // console.log('中试中心信息:', pilotInfo.value);
      } catch (error) {
        console.error('获取中试中心信息失败:', error);
      } finally {
        loading.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '技术服务平台'
        }, {
          label: '中试中心'
        }]
      }), _createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "page-title"
      }, "中试中心", -1)), pilotInfo.value?.descInfo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: "中心简介",
        "show-more": false
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: pilotInfo.value.descInfo.coveImage,
        alt: "中心简介"
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString(pilotInfo.value.descInfo.description), 1)])])])) : _createCommentVNode("", true), pilotInfo.value?.projectNum ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pilotInfo.value.projectNum, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "project-card blue-border",
          key: item.key
        }, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.key) + "：", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(item.value), 1)]);
      }), 128))])])) : _createCommentVNode("", true), pilotInfo.value?.articleList ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "cases-title-wrapper"
      }, [_createElementVNode("div", {
        class: "cases-title"
      }, "成功案例"), _createElementVNode("div", {
        class: "cases-title-underline"
      })], -1)), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_carousel, {
        height: "450px",
        "indicator-position": "outside",
        arrow: "always",
        interval: 5000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(pilotInfo.value.articleList.length / 5), (page, pageIndex) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: pageIndex
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pilotInfo.value.articleList.slice(pageIndex * 5, (pageIndex + 1) * 5), item => {
              return _openBlock(), _createElementBlock("div", {
                class: "case-card",
                key: item.id,
                onClick: $event => goToDetail(item.id)
              }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
                src: item.coverImage,
                alt: "成功案例"
              }, null, 8, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(item.publishTime), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(item.summary), 1)])], 8, _hoisted_16);
            }), 128))])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])])])) : _createCommentVNode("", true), pilotInfo.value?.descInfo ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(SectionTitle, {
        title: "服务流程",
        "show-more": false
      }), _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
        src: pilotInfo.value.descInfo.footerImage,
        alt: "服务流程"
      }, null, 8, _hoisted_25)])])) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "section apply-section"
      }, [_createElementVNode("button", {
        class: "apply-btn"
      }, "开始申请")], -1))]), _createVNode(Footer)]);
    };
  }
});